export default "__VITE_PUBLIC_ASSET__8c770046__"